import CloseReceipt from "./CloseReceipt";

export default CloseReceipt;
